import React, { useEffect, useState } from 'react';
import { getAdminStats, seedData } from '../../services/api';
import { Map, FolderOpen, CalendarCheck, Clock, Loader2 } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [seeding, setSeeding] = useState(false);
  const [seedMsg, setSeedMsg] = useState('');

  const fetchStats = async () => {
    try {
      const res = await getAdminStats();
      setStats(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStats(); }, []);

  const handleSeed = async () => {
    setSeeding(true);
    try {
      const res = await seedData();
      setSeedMsg(res.data.message);
      fetchStats();
    } catch (err) {
      setSeedMsg(err.response?.data?.detail || 'Hata oluştu');
    } finally {
      setSeeding(false);
    }
  };

  if (loading) return <div className="flex items-center justify-center py-20"><Loader2 className="animate-spin text-[#3D4A26]" size={32} /></div>;

  const cards = [
    { label: 'Toplam Tur', value: stats?.tours || 0, sub: `${stats?.activeTours || 0} aktif`, icon: Map, color: 'bg-[#C8D843]/15 text-[#3D4A26]' },
    { label: 'Kategoriler', value: stats?.categories || 0, sub: 'destinasyon, aktivite, koleksiyon', icon: FolderOpen, color: 'bg-blue-50 text-blue-600' },
    { label: 'Rezervasyonlar', value: stats?.reservations || 0, sub: `${stats?.pendingReservations || 0} bekleyen`, icon: CalendarCheck, color: 'bg-amber-50 text-amber-600' },
  ];

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <div key={card.label} className="bg-white rounded-xl border border-gray-200 p-5">
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${card.color}`}>
                  <Icon size={22} />
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#1B1B1B]">{card.value}</p>
                  <p className="text-sm text-gray-500">{card.label}</p>
                  <p className="text-xs text-gray-400">{card.sub}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Seed Data */}
      {stats && stats.tours === 0 && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <h3 className="font-bold text-[#1B1B1B] mb-2" style={{ fontFamily: 'DM Sans, sans-serif' }}>Başlangıç Verileri</h3>
          <p className="text-sm text-gray-600 mb-4">Henüz veri yok. Camption turlarını yüklemek için aşağıdaki butona tıklayın.</p>
          <button
            onClick={handleSeed} disabled={seeding}
            className="bg-[#3D4A26] text-white font-semibold px-6 py-2.5 rounded-lg hover:bg-[#2d3a1a] transition-colors disabled:opacity-50 flex items-center gap-2"
          >
            {seeding ? <><Loader2 size={16} className="animate-spin" /> Yükleniyor...</> : 'Başlangıç Verilerini Yükle'}
          </button>
          {seedMsg && <p className="mt-3 text-sm text-[#3D4A26] font-medium">{seedMsg}</p>}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
